import { render, staticRenderFns } from "./AddNewCcpItemPopUp.vue?vue&type=template&id=aba0183a&scoped=true&"
import script from "./AddNewCcpItemPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewCcpItemPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCcpItemPopUp.vue?vue&type=style&index=0&id=aba0183a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba0183a",
  null
  
)

export default component.exports